<template>
  <v-dialog v-model="editDialogAgricultural" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t("Edit Weight Auditor's information") }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs4 pa-2>
                <v-menu v-model="dateModal" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="weightAuditorInfo.date"
                    :label="`${$t('Date')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="Date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('Date')"
                    v-validate="'required|date_format:yyyy-MM-dd'"
                  />
                  <v-date-picker @change="dateModal = false" v-model="weightAuditorInfo.date" />
                </v-menu>
              </v-flex>

              <v-flex xs4 pa-2>
                <v-autocomplete
                  :items="shiftTimes"
                  v-model="weightAuditorInfo.shift_time"
                  :label="`${$t('Shift Time')} *`"
                  box
                  hide-details
                  :error="errors.has('Shift Time')"
                  v-validate="'required'"
                  background-color="white"
                  data-vv-name="Shift Time"
                  :menu-props="{ transition: 'slide-y-transition' }"
                  :readonly="detailLength > 0 ? true : false"
                />
              </v-flex>

              <v-flex xs4 pa-2>
                <v-autocomplete
                  :items="fullFactoriesList"
                  v-model="weightAuditorInfo.factory_id_fk"
                  :label="`${$t('Factory')} *`"
                  box
                  hide-details
                  :error="errors.has('Factory')"
                  background-color="white"
                  data-vv-name="Factory"
                  v-validate="'required'"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-layout justify-end>
                <v-flex xs2>
                  <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                    <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                    {{ $t('Update') }}
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-flex xs12 class="title no-select pb-1">
                <hr style="margin: 10px 0px" />
                <v-layout>{{ $t('Details') }}</v-layout>
              </v-flex>

              <v-flex xs12 style="margin-top: 20px">
                <v-layout row wrap class="form-table-header">
                  <v-flex xs2 class="pa-2 form-table-content">
                    <span style="width:20%; float: left; text-align: center; font-size: 16px">#</span>
                    <span style="width: 80%">{{ $t('Time') }}</span>
                  </v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('1 Inch') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('1.5 Inch') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('2 Inch') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('2.5 Inch') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('3 Inch') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('4 Inch') }}</v-flex>
                  <v-flex xs1 class="pa-2 form-table-content">{{ $t('5 Inch') }}</v-flex>
                  <v-flex xs2 class="pa-2 form-table-content">{{ $t('Note') }}</v-flex>
                  <v-flex xs1 class="form-table-content">
                    <v-tooltip top>
                      <v-btn label @click="addRow()" small slot="activator" icon color="green">
                        <v-icon color="white">add</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>

                <template v-if="rowNumbers > 0">
                  <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                    <v-flex xs2 class="pa-1">
                      <span
                        class="pa-1"
                        style="width:20%; float: left; text-align: center; margin-top: 20px; font-size: 16px"
                        >{{ index + 1 }}</span
                      >
                      <v-autocomplete
                        style="width: 80%"
                        v-model="time[index]"
                        :label="`${$t('Time')} *`"
                        :items="weightAuditorInfo.shift_time === 'Morning' ? morningTimes : eveningTimes"
                        hide-details
                        box
                        :data-vv-name="'Time' + (index + 1)"
                        background-color="white"
                        :error="errors.has('Time' + (index + 1))"
                        v-validate="'required'"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_1[index]"
                        :label="`${$t('1 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'1 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('1 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_2[index]"
                        :label="`${$t('1.5 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'1.5 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('1.5 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_3[index]"
                        :label="`${$t('2 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'2 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('2 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_4[index]"
                        :label="`${$t('2.5 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'2.5 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('2.5 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_5[index]"
                        :label="`${$t('3 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'3 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('3 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_6[index]"
                        :label="`${$t('4 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'4 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('4 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs1 class="pa-1">
                      <v-text-field
                        v-model="field_7[index]"
                        :label="`${$t('5 Inch')} *`"
                        hide-details
                        box
                        :data-vv-name="'5 Inch' + (index + 1)"
                        background-color="white"
                        :error="errors.has('5 Inch' + (index + 1))"
                        v-validate="'required|decimal:4|min_value:0'"
                        data-vv-delay="1000"
                      />
                    </v-flex>
                    <v-flex xs2 class="pa-1">
                      <v-text-field
                        v-model="note[index]"
                        :label="$t('Note')"
                        hide-details
                        box
                        :data-vv-name="'Note' + (index + 1)"
                        background-color="white"
                      />
                    </v-flex>
                    <v-flex xs1 pa-2 pt-3 style="text-align: center">
                      <v-tooltip v-if="status[index] === 'save'" top>
                        <v-btn
                          style="margin: 0px !important"
                          label
                          flat
                          @click="saveRow(index)"
                          small
                          slot="activator"
                          icon
                          color="success"
                        >
                          <v-icon>save</v-icon>
                        </v-btn>
                        <span>{{ $t('Save') }}</span>
                      </v-tooltip>

                      <v-tooltip v-else-if="status[index] === 'update'" top>
                        <v-btn
                          style="margin: 0px !important"
                          label
                          flat
                          @click="updateRow(index)"
                          small
                          slot="activator"
                          icon
                          color="primary"
                        >
                          <v-icon>save</v-icon>
                        </v-btn>
                        <span>{{ $t('Update') }}</span>
                      </v-tooltip>

                      <v-tooltip top v-if="status[index] === 'save'">
                        <v-btn
                          style="margin: 0px !important"
                          label
                          flat
                          @click="removeRow(index)"
                          small
                          slot="activator"
                          icon
                          color="error"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Remove this row') }}</span>
                      </v-tooltip>

                      <v-tooltip top v-else-if="status[index] === 'update'">
                        <v-btn
                          style="margin: 0px !important"
                          label
                          flat
                          @click="showConfirmDeletion(index)"
                          small
                          slot="activator"
                          icon
                          color="error"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Delete this record') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>

      <confirm-deletion
        :deleteDialog="deleteDialog"
        :btnDeleteLoading="btnDeleteLoading"
        @hidemodal="deleteDialog = false"
        @confirm="deleteRow()"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  name: 'edit-component-agricultural',

  props: {
    editDialogAgricultural: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      dateModal: false,
      deleteDialog: false,
      btnDeleteLoading: false,
      rowNumbers: 0,
      status: [],
      time: [],
      field_1: [],
      field_2: [],
      field_3: [],
      field_4: [],
      field_5: [],
      field_6: [],
      field_7: [],
      note: [],
      detailsId: [],
      detailLength: 0,
      deleteId: 0,
      theIndex: 0
    }
  },

  computed: {
    ...mapGetters({
      weightAuditorInfo: 'weightAuditors/getWeightAuditorInfo',
      shiftTimes: 'productions/getShiftTimes',
      weightAuditorTypes: 'weightAuditors/getWeightAuditorTypes',
      morningTimes: 'weightAuditors/getMorningTimes',
      eveningTimes: 'weightAuditors/getEveningTimes',
      fullFactoriesList: 'factories/getFullFactoriesList'
    })
  },

  watch: {
    editDialogAgricultural: {
      immediate: false,
      handler() {
        if (this.editDialogAgricultural) {
          this.rowNumbers = 0
          this.addEscKeyListener()
          this.status = []
          this.time = []
          this.detailsId = []
          this.field_1 = []
          this.field_2 = []
          this.field_3 = []
          this.field_4 = []
          this.field_5 = []
          this.field_6 = []
          this.field_7 = []
          this.note = []
          this.detailLength = this.weightAuditorInfo.details.length
          if (this.weightAuditorInfo.details.length > 0) {
            this.weightAuditorInfo.details.forEach(data => {
              this.rowNumbers = this.weightAuditorInfo.details.length
              this.status.push('update')
              this.detailsId.push(data.auditor_detail_id)
              this.time.push(data.time)
              this.field_1.push(data.field_1)
              this.field_2.push(data.field_2)
              this.field_3.push(data.field_3)
              this.field_4.push(data.field_4)
              this.field_5.push(data.field_5)
              this.field_6.push(data.field_6)
              this.field_7.push(data.field_7)
              this.note.push(data.note)
            })
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateWeightAuditorInfo: 'weightAuditors/updateWeightAuditorInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialogAgricultural) {
          this.$emit('hidemodal')
        }
      })
    },

    addRow() {
      this.status.push('save')
      this.detailsId.push(0)
      this.rowNumbers = this.rowNumbers + 1
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.time.splice(index, 1)
      this.detailsId.splice(index, 1)
      this.status.splice(index, 1)
      this.field_1.splice(index, 1)
      this.field_2.splice(index, 1)
      this.field_3.splice(index, 1)
      this.field_4.splice(index, 1)
      this.field_5.splice(index, 1)
      this.field_6.splice(index, 1)
      this.field_7.splice(index, 1)
      this.note.splice(index, 1)
    },

    saveRow(index) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let formData = new FormData()
          formData.append('time', this.time[index])
          formData.append('field_1', this.field_1[index])
          formData.append('field_2', this.field_2[index])
          formData.append('field_3', this.field_3[index])
          formData.append('field_4', this.field_4[index])
          formData.append('field_5', this.field_5[index])
          formData.append('field_6', this.field_6[index])
          formData.append('field_7', this.field_7[index])
          if (this.note[index]) {
            formData.append('note', this.note[index])
          }
          formData.append('weight_auditor_id_fk', this.weightAuditorInfo.weight_auditor_id)

          Axios.post('weights_auditor_details_store', formData)
            .then(response => {
              this.detailsId[index] = response.data.data.auditor_detail_id
              this.status[index] = 'update'
              this.addRow()
              helpers.ktNotify({
                type: 'success',
                text: 'Saved Successfully'
              })
            })
            .catch(error => {
              helpers.showErrorMessage(error, 'An error occurred, update failed')
            })
        }
      })
    },

    updateRow(index) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          let formData = new FormData()
          formData.append('time', this.time[index])
          formData.append('field_1', this.field_1[index])
          formData.append('field_2', this.field_2[index])
          formData.append('field_3', this.field_3[index])
          formData.append('field_4', this.field_4[index])
          formData.append('field_5', this.field_5[index])
          formData.append('field_6', this.field_6[index])
          formData.append('field_7', this.field_7[index])
          if (this.note[index]) {
            formData.append('note', this.note[index])
          }
          formData.append('_method', 'patch')

          let detailsId = this.detailsId[index]

          Axios.post(`weights_auditor_details_update/${detailsId}`, formData)
            .then(() => {
              helpers.ktNotify({
                type: 'success',
                text: 'Updated Successfully'
              })
            })
            .catch(error => {
              helpers.showErrorMessage(error, 'An error occurred, update failed')
            })
        }
      })
    },

    showConfirmDeletion(index) {
      this.theIndex = index
      this.deleteId = this.weightAuditorInfo.details[index].auditor_detail_id
      this.deleteDialog = true
    },

    deleteRow() {
      Axios.delete(`weights_auditor_details_destroy/${this.deleteId}`).then(() => {
        this.removeRow(this.theIndex)
        this.deleteId = 0
        this.btnDeleteLoading = false
        this.deleteDialog = false
        helpers.ktNotify({
          type: 'success',
          text: 'Deleted Successfully'
        })
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('date', this.weightAuditorInfo.date)
            formData.append('shift_time', this.weightAuditorInfo.shift_time)
            formData.append('factory_id_fk', this.weightAuditorInfo.factory_id_fk)

            let payload = {
              id: this.weightAuditorInfo.weight_auditor_id,
              formData
            }
            this.updateWeightAuditorInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
